import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined';
import Section from '../components/Section.jsx';
import { audiences } from '../content.js';

export default function Audiences() {
  return (
    <Section
      id="para-quem"
      eyebrow="Para quem é"
      title="Três perfis, um único ecossistema"
      subtitle="Uma pessoa pode acumular perfis: morador que também vende, síndico que compra do vizinho, fornecedor que mora no próprio condomínio."
    >
      <Grid container spacing={3}>
        {audiences.map((audience) => (
          <Grid key={audience.id} size={{ xs: 12, md: 4 }}>
            <Card elevation={0} sx={{ height: '100%' }}>
              <CardContent sx={{ p: 3.5 }}>
                <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', mb: 2 }}>
                  <Typography variant="h5" component="h3">
                    {audience.title}
                  </Typography>
                  <Chip
                    size="small"
                    label={audience.price}
                    color={audience.price === 'Gratuito' ? 'success' : 'secondary'}
                    variant={audience.price === 'Gratuito' ? 'filled' : 'outlined'}
                  />
                </Stack>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  {audience.summary}
                </Typography>

                <List dense disablePadding>
                  {audience.bullets.map((bullet) => (
                    <ListItem key={bullet} disableGutters sx={{ alignItems: 'flex-start' }}>
                      <ListItemIcon sx={{ minWidth: 32, mt: 0.5, color: 'secondary.main' }}>
                        <CheckCircleOutlineIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary={bullet} primaryTypographyProps={{ variant: 'body2' }} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}
